module.exports = __webpack_public_path__ + "img/1514931743.eee777c8.jpg";